var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnarchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H14.7797V4.62798H0V0ZM1.64218 1.64218V2.98579H13.1375V1.64218H1.64218Z",
    fill: "#39414A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.862549 2.99817H13.9171V13.5977H0.862549V2.99817ZM2.50473 4.64035V11.9555H12.2749V4.64035H2.50473Z",
    fill: "#39414A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50008 8.7072L5.62508 10.5822L4.91797 9.87509L6.79297 8.00009L5.00008 6.2072L5.70718 5.50009L7.50008 7.29298L9.29306 5.5L10.0002 6.20711L8.20718 8.00009L10.0823 9.87518L9.37516 10.5823L7.50008 8.7072Z",
    fill: "#39414A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchive);
export default __webpack_public_path__ + "static/media/Unarchive.8309a83e1c71fd80288750fba7762005.svg";
export { ForwardRef as ReactComponent };